import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import Button from '../../elements-buttons/Button';
import hoc from './hoc';
import { FormattedMessage } from 'react-intl';

const DeletePricingModal = ({
  deletePricing,
  isLoading,
  error,
  dispatch,
  onClose,
  ...props
}) => (
  <BootstrapModal
    {...props}
    onClose={onClose}
    header={
      <h3><FormattedMessage id="hosting.delete_pricing_modal.heading" defaultMessage="Delete calendar rate?" /></h3>
    }
    modalSize="sm-size modal-sm"
    modalClass="delete-pricing-modal"
    body={
      <div className="flex space-between">
        <div>
          <Button
            category="default"
            type="button"
            onClick={onClose}
          >
            <FormattedMessage id="hosting.delete_pricing_modal.button_text_cancel" defaultMessage="Cancel" />
          </Button>
        </div>
        <div>
          <Button
            category="primary"
            isLoading={isLoading}
            onClick={deletePricing}
          >
            <FormattedMessage id="hosting.delete_pricing_modal.button_text_delete" defaultMessage="Delete" />
          </Button>
        </div>
      </div>
    }
    footer={error && <div className="margin-md-top margin-lg-bottom text-red text-center">
      <FormattedMessage id="hosting.delete_pricing_modal.error_message" defaultMessage="Something happened, please refresh and try again later." /></div>}
  />
);

DeletePricingModal.propTypes = {
  onClose: PropTypes.func,
  deletePricing: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  dispatch: PropTypes.func
};

export default hoc(DeletePricingModal);
